/**
 * 网站相关设置
 */
const options = {
  namespaced: true,
  state: () => ({
    // 预览模式
    preview: {
      enable: false,
      id: null,
    },
    // 基本设置
    base: {},
    // 主题配置
    theme: {},
    // 路由信息
    routeName: null
  }),
  mutations: {
    save(state, { payload }) {
      const { base, theme, routeName } = payload;

      state.base = {
        ...state.base,
        ...base
      }
      state.theme = {
        ...state.theme,
        ...theme
      }
      state.routeName = routeName
    },
    // 设置是否处于预览模式
    savePreviewMode(state, { payload }) {
      const { enable, id } = payload;
      state.preview = {
        enable,
        id
      }
    }
  }
}

export default options
